
import  axios  from 'axios';
import {loadCompanysDataWithUserId} from "../company";
import {loadSingleUserDataInStore,loadSingleUserData,getSingleUser} from "../user/actions";
//import {clearAllFiltersInStore, SET_CLEAR_ALL_FILTER} from "../fax/actions";

//import AppUtils from "../../../utils/AppUtils";
//import AppUtils from "../../../views/Common/Utils/AppUtils"

export const LOAD_PARKINGINCIDENT_DATA = 'parkingincident/LOAD_PARKINGINCIDENT_DATA';
export const DELETE_A_PARKINGINCIDENT = 'parkingincident/DELETE_A_PARKINGINCIDENT';
export const SAVE_A_PARKINGINCIDENT = 'parkingincident/SAVE_A_PARKINGINCIDENT';
export const UPDATE_A_PARKINGINCIDENT = 'parkingincident/UPDATE_A_PARKINGINCIDENT';
export const SET_PARKINGINCIDENT_STATUS_FILTER = 'parkingincident/SET_PARKINGINCIDENT_STATUS_FILTER';
export const SET_PARKINGINCIDENT_VIN_FILTER = 'parkingincident/SET_PARKINGINCIDENT_VIN_FILTER';
export const SET_PARKINGINCIDENT_PLATE_FILTER = 'parkingincident/SET_PARKINGINCIDENT_PLATE_FILTER';
export const SET_PARKINGINCIDENT_STARTTIME_FILTER = 'parkingincident/SET_PARKINGINCIDENT_STARTTIME_FILTER';
export const SET_PARKINGINCIDENT_ENDTIME_FILTER = 'parkingincident/SET_PARKINGINCIDENT_ENDTIME_FILTER';
export const SET_PARKINGINCIDENT_MODEL_FILTER = 'parkingincident/SET_PARKINGINCIDENT_MODEL_FILTER';
export const SET_PARKINGINCIDENT_MAKE_FILTER = 'parkingincident/SET_PARKINGINCIDENT_MAKE_FILTER';
export const SET_PARKINGINCIDENT_COLOR_FILTER = 'parkingincident/SET_PARKINGINCIDENT_COLOR_FILTER';
export const SET_PARKINGINCIDENT_YEAR_FILTER = 'parkingincident/SET_PARKINGINCIDENT_YEAR_FILTER';
export const SET_PARKINGINCIDENT_CLEAR_ALL_FILTER = 'parkingincident/SET_PARKINGINCIDENT_CLEAR_ALL_FILTER';
export const CLEAR_A_PARKINGINCIDENT_ERROR_MESSAGE = 'parkingincident/CLEAR_A_PARKINGINCIDENT_ERROR_MESSAGE';
export const UPLOAD_PARKINGINCIDENT_PICTURE = 'parkingincident/UPLOAD_PARKINGINCIDENT_PICTURE';
export const GET_PARKINGINCIDENT_PICTURE_IDS = 'parkingincident/GET_PARKINGINCIDENT_PICTURE_IDS';



export function uploadAParkingIncidentPictureInStore(argTowUploadResponse ,argErrorMsg) {
    return {
        type: UPLOAD_PARKINGINCIDENT_PICTURE,
        towUploadResponse:argTowUploadResponse,
        errorMsg:argErrorMsg
    }
}

export function clearParkingIncidentErrorMsgInStore(){
    return {
        type: CLEAR_A_PARKINGINCIDENT_ERROR_MESSAGE,

    }
}

export function loadParkingIncidentDataInStore(argTowjobDataArray) {
    return {
        type: LOAD_PARKINGINCIDENT_DATA,
        parkingincidentsData:argTowjobDataArray
    }
}


export function loadAVehicleParkingIncidentsSummaryDataInStore(argTowjobDataArray) {
    return {
        type: LOAD_PARKINGINCIDENT_DATA,
        parkingincidentsData:argTowjobDataArray
    }
}


export function deleteAParkingIncidentInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_PARKINGINCIDENT,
        deleteTowjobResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAParkingIncidentDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_PARKINGINCIDENT,
        saveTowjobResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAParkingIncidentDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_PARKINGINCIDENT,
        updateTowjobResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}


export function setParkingIncidentStatusFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_STATUS_FILTER,
        towStatusFilter:argFilter,
    }
}


export function setParkingIncidentVinFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_VIN_FILTER,
        towVinFilter:argFilter,
    }
}

export function setParkingIncidentPlateFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_PLATE_FILTER,
        towPlateFilter:argFilter,
    }
}

export function setParkingIncidentStartTimeFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_STARTTIME_FILTER,
        towStartTimeFilter:argFilter,
    }
}

export function setParkingIncidentEndTimeFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_ENDTIME_FILTER,
        towEndTimeFilter:argFilter,
    }
}

export function setParkingIncidentModelFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_MODEL_FILTER,
        towModelFilter:argFilter,
    }
}

export function setParkingIncidentMakeFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_MAKE_FILTER,
        towMakeFilter:argFilter,
    }
}

export function setParkingIncidentColorFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_COLOR_FILTER,
        towColorFilter:argFilter,
    }
}

export function setParkingIncidentYearFilterInStore(argFilter ) {
    return {
        type: SET_PARKINGINCIDENT_YEAR_FILTER,
        towYearFilter:argFilter,
    }
}

export function clearParkingIncidentAllFiltersInStore() {
    return {
        type: SET_PARKINGINCIDENT_CLEAR_ALL_FILTER,

    }
}

export function loadParkingIncidentJobsPictureIdsInStore(argTowjobDataArray,argErrorMsg) {
    return {
        type: GET_PARKINGINCIDENT_PICTURE_IDS,
        parkingincidentspictureids:argTowjobDataArray,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/
//****************************************
 //Below is for update a Stream
 //****************************************
export function clearParkingIncidentErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearTowErrorMsgInStore());
    }
}

//****************************************
//Below is for update a Stream
//****************************************
export function updateAParkingIncident(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateAParkingIncidentbOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateAParkingIncidentDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error updating a ParkingIncident" + errorObj.statusText + errorObj.status);
            dispatch(updateAParkingIncidentDataInStore({}, errorObj));
        });
    }//end of return
}


function updateAParkingIncidentOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAParkingIncident(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on saving a ParkingIncident " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAParkingIncident(argURL, argTowjob,argCompanyId ,argIdToken, argUserId ){

    let baseUrl = argURL+"users/"+ argUserId+"/propertymanagers/"+argCompanyId+"/parkingincidents/"+argTowjob.id ;
    console.log(" on posting a parkingincident the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argTowjob ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAParkingIncident(argURL, argTowjobInfo, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveAParkingIncidentOnServer(argURL, argTowjobInfo, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAParkingIncidentDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText} ));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error saving a Tow Job " + err.response.statusText + err.response.status );
            dispatch(saveAParkingIncidentDataInStore({}, errorObj ));
        });
    }//end of return
}


function saveAParkingIncidentOnServer( argURL, argTowjobInfo, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAParkingIncident(argURL, argTowjobInfo, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on saving a parkingincident " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAParkingIncident(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"propertymanagers/"+argCompanyId+"/parkingincidents";
    console.log(" on posting a parkingincident the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAParkingIncident(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteATowjobOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteAParkingIncidentInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAParkingIncidentInStore({}, err));
        });
    }//end of return
}


function deleteAParkingIncidentOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAParkingIncident(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a Towjob " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAParkingIncident(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/propertymanagers"+"/"+argRealCompanyId+"/parkingincidents/"+argStorageId;
    console.log(" on deleteing a Towjob the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

//get list of tow summary
export function loadAVehicleParkingIncidentsSummaryData(argURL, argVehicleId, argVehiclePlateNumber, argVehicleState) {
    return (dispatch, getState) => {
        const state = getState();

        if((state.user.saveUserResp == null) ||(state.user.saveUserResp.id == null) || (state.user.saveUserResp.id == undefined)) {
            getSingleUser(argURL, state.login.loginData.idToken).then(function(userData){


                //dispatch(loadSingleUserDataInStore(userData));
                //dispatch(loadCompanysDataWithUserId(argURL,userData.id ));

                getListOfAVehicleParkingIncidentsSummary(argURL, argVehicleId, argVehiclePlateNumber, argVehicleState, state.login.loginData.idToken, userData.id).then(function(companysList){

                    dispatch(loadAVehicleParkingIncidentsSummaryDataInStore(companysList));

                }, function(err){
                    console.log("I had an error getting loadParkingIncidentsData" + err);
                });

            }, function(err){
                console.log("I had an error getting Farms Data2" + err);
            });




        }else{
            getListOfAVehicleParkingIncidentsSummary(argURL, argVehicleId, argVehiclePlateNumber, argVehicleState, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

                dispatch(loadAVehicleParkingIncidentsSummaryDataInStore(companysList));

            }, function(err){
                console.log("I had an error getting loadTParkingIncidentsData" + err);
            })};
    }//end of return
}

function getListOfAVehicleParkingIncidentsSummary( argURL, argVehicleId ,argVehiclePlateNumber, argVehicleState,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfAVehicleParkingIncidentsSummary(argURL, argVehicleId, argVehiclePlateNumber, argVehicleState ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Some error occurred on getting list of ParkingIncidents " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

function getArrayOfGetsForListOfAVehicleParkingIncidentsSummary(argURL,argVehicleId ,argVehiclePlateNumber, argVehicleState,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/vehicles/"+argVehicleId+"/parkingincidents?plate="+argVehiclePlateNumber+"&state="+argVehicleState;
    console.log(" on getting list of ParkingIncidents  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}




//Get list of tows

export function loadParkingIncidentsData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();

        if((state.user.saveUserResp == null) ||(state.user.saveUserResp.id == null) || (state.user.saveUserResp.id == undefined)) {
            getSingleUser(argURL, state.login.loginData.idToken).then(function(userData){

                // dispatch(loadTowjobDataInStore(companysList));
                dispatch(loadSingleUserDataInStore(userData));
                dispatch(loadCompanysDataWithUserId(argURL,userData.id ));

                getListOfParkingIncidents(argURL, state.company.selectedCompany, state.login.loginData.idToken, userData.id).then(function(companysList){

                    dispatch(loadParkingIncidentDataInStore(companysList));

                }, function(err){
                    console.log("I had an error getting loadParkingIncidentsData" + err);
                });

            }, function(err){
                console.log("I had an error getting ParkingIncident" + err);
            });




        }else{
        getListOfParkingIncidents(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadParkingIncidentDataInStore(companysList));

    }, function(err){
        console.log("I had an error getting loadParkingIncidentsData" + err);
        })};
    }//end of return
}

function getArrayOfGetsForListOfParkingIncidents(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/propertymanagers"+argCompanyId+"/parkingincidents";
    console.log(" on getting list of Towjobs  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfParkingIncidents( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfParkingIncidents(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Some error occurred on getting list of ParkingIncidents " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


//These are for loadJobsWIthFilters
export function loadParkingIncidentsDataWithFilter(argURL, argCompanyId, argFilter) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfParkingIncidentsWithFilter(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id, argFilter).then(function(companysList){

            dispatch(loadParkingIncidentDataInStore(companysList));

        }, function(err){
            console.log("I had an error getting ParkingIncident" + err);
        });
    }//end of return
}

function getListOfParkingIncidentsWithFilter( argURL, argCompanyId ,argIdToken, argUserId, argFilter ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfParkingIncidentsWithFilter(argURL, argCompanyId ,argIdToken, argUserId, argFilter )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Some error occurred on getting list of ParkingIncidents " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}
function getArrayOfGetsForListOfParkingIncidentsWithFilter(argURL,argCompanyId ,argIdToken, argUserId, argFilter  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/propertymanagers/"+argCompanyId+"/parkingincidents"+argFilter;
    console.log(" on getting list of ParkingIncident  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//These are upload funcations
//


//****************************************
//Below is Upload
//****************************************
export function uploadAParkingIncidentPicture(argURL, argFormData, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        uploadAParkingIncidentPictureOnServer(argURL, argFormData, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(uploadAParkingIncidentPictureInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText} ));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error saving a Tow Job " + err.response.statusText + err.response.status );
            dispatch(uploadAParkingIncidentPictureInStore({}, errorObj ));
        });
    }//end of return
}


function uploadAParkingIncidentPictureOnServer( argURL, argFormData, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForUploadAParkingIncidentPicture(argURL, argFormData, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occurred on saving a ParkingIncident " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForUploadATParkingIncidentPicture(argURL, argFormData, argCompanyId ,argIdToken, argUserId){

    let baseUrl = argURL+"users/"+ argUserId+"/propertymanagers/"+argCompanyId+"/uploads";
    console.log(" on posting a picture the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argFormData ,{headers: {"Authorization" : `Bearer ${argIdToken}`, "Content-Type": "multipart/form-data"}} ));
    }
    return arrayOfGets;
}

//These are for getting pictures from the server loadTowJobsPictureIds
export function loadParkingIncidentsPictureIds(argURL, argVehicleId, argTowId ) {
    console.log("I am calling  loadParkingIncidentJobsPictureIds" );
    return (dispatch, getState) => {
        const state = getState();
        getListOfTowJobsPictureIds(argURL, argVehicleId, state.login.loginData.idToken, state.user.saveUserResp.id, argTowId ).then(function(pictureIdsList){

            dispatch(loadParkingIncidentsPictureIdsInStore(pictureIdsList));

        }, function(err){
            console.log("I had an error getting loadParkingIncidentsPictureIds" + err);
        });
    }//end of return
}




function getListOfParkingIncidentsPictureIds( argURL, argVehicleId ,argIdToken, argUserId, argTowId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || ( argURL.length !== 0)){
            axios.all(getArrayOfGetsForListOfParkingIncidentsPictureIds(argURL, argVehicleId ,argIdToken, argUserId, argTowId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occurred on getting list of ParkingIncidents " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


function getArrayOfGetsForListOfParkingIncidentsPictureIds(argURL,argVehicleId ,argIdToken, argUserId, argTowId  ){


    let baseUrl = argURL+"users/"+ argUserId+"/vehicle/"+ argVehicleId+"/parkingincidentpictures/"+argTowId;
    console.log(" on getting list of ParkingIncidentpictures  ids the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


/*  This was for test
export function testUpload(){

    // let img1 = yourFile1
    //let img2 = yourFile2
    const formData = new FormData();
// It is of paramount importance for these to have the same name (the first paramater - here 'images')else multer will give you a very cryptic error
    //formData.append("images", img1);
    //formData.append("images", img2);
// you can of course append anything else you'd like
    formData.append("joke", "this is a poor mama joke");
    axios({
        method: "POST",
        url:  "http://localhost:2500/uploads",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
      .then(response => {
            if (response.status === 200) {
                console.log("Success, firm added")
            } else {
                console.log("Error occurred")
            }
        }
      ).catch(e => {
        console.log(e)
    })


}
*/
export function setParkingIncidentStatusFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentStatusFilterInStore(argStatus));
    }
}

export function setParkingIncidentVinFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentVinFilterInStore(argStatus));
    }
}

export function setParkingIncidentPlateFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentPlateFilterInStore(argStatus));
    }
}

export function setParkingIncidentStartTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentStartTimeFilterInStore(argStatus));
    }
}
export function setParkingIncidentEndTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentEndTimeFilterInStore(argStatus));
    }
}

export function setParkingIncidentModelFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentModelFilterInStore(argStatus));
    }
}

export function setParkingIncidentMakeFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentMakeFilterInStore(argStatus));
    }
}


export function setParkingIncidentColorFilter(argStatus){
    return (dispatch) => {
        dispatch(setParkingIncidentColorFilterInStore(argStatus));
    }
}

export function setParkingIncidentYearFilter(argStatus){
    return (dispatch) => {
        dispatch(setTowYearFilterInStore(argStatus));
    }
}

export function clearParkingIncidentAllFilters(){
    return (dispatch) => {
        dispatch(clearParkingIncidentAllFiltersInStore());
    }
}
